<wbo-edit-grid [data]="model.data.barcodes" [editable]="true"
               [removable]="true" [entityPath]="'barcodes'" [showHeader]="false"
               [title]="title">
    <wbo-text-column field="value" [editable]="true"></wbo-text-column>
    <wbo-edit-grid-add-row>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
